import { createSlice } from "@reduxjs/toolkit";
import { decryptData, encryptData } from "../../config/lib";

const getUserInfoFromLocal = () => {
  if (sessionStorage.getItem("userInfo"))
    return JSON.parse(decryptData(sessionStorage.getItem("userInfo")));
  else return { role: "guest", token: null };
  // else return { role: "user", token: null };
};

export const authSlice = createSlice({
  name: "auth",
  initialState: getUserInfoFromLocal(),
  reducers: {
    login: (state, action) => {
      sessionStorage.setItem(
        "userInfo",
        encryptData(JSON.stringify(action.payload))
      );

      state.role = action.payload.role;
      state.token = action.payload.access;
      state.name = action.payload.name;
      state.id = action.payload.id;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
    },
    logout: (state) => {
      sessionStorage.removeItem("userInfo");

      state.role = "guest";
      state.token = null;
      state.email = null;
      state.phone = null;
      state.name = null;
      state.id = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
